import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import AdminLayout from 'components/layouts/admin/Layout';

const AdminIndex: FC = () => {
  window.document.title = 'Users';

  return (
    <AdminLayout>
      <section className="w-full rounded-md bg-zinc-50 pt-4 md:mx-auto md:h-screen md:p-5 lg:container">
        <Outlet />
      </section>
    </AdminLayout>
  );
};

export default AdminIndex;
